<div [formGroup]="emailQuoteForm">
  <h3 class="headline5-main-title">{{ emailTexts().emailQuoteTitle }}</h3>
  @if (showAlert()) {
    <pc-alert-card
      @shortFadeOut
      #alertCard
      [guidance]="emailTexts().emailQuoteAlertSubTitle"
      [showIcon]="false"
      [title]="emailTexts().emailQuoteAlertTitle"
      [type]="'bottom'"
      (@shortFadeOut.done)="onAnimationDone()"
    ></pc-alert-card>
  } @else if (!isAnimating()) {
    <div class="email-quote-container">
      <span class="sub-title" [innerHTML]="privacyPolicyLink()"></span>
      <pc-input
        name="email"
        type="email"
        [businessUnit]="BusinessUnit.AU"
        [enableAutocomplete]="true"
        [formControl]="email"
        [isSalesInput]="true"
        [placeholder]="emailTexts().emailQuoteInputLabel"
      ></pc-input>
    </div>
    <pc-gradient-btn
      class="edit-btn"
      [icon]="PcButtonIcon.RIGHT_ARROW"
      [isDisabled]="isButtonDisabled()"
      [isLoading]="isBusy()"
      [text]="emailTexts().emailQuoteButton"
      (btnClicked)="submit()"
    ></pc-gradient-btn>
  }
</div>
